export function canonicalAbilityStateKey(cardId, state) {
    return `@cards/ability/${encodeURIComponent(cardId)}/${state.abilityId}/${state.slot}`;
}
export function persistedAbilityStateKey(cardId, state) {
    return state.legacyKey ?? canonicalAbilityStateKey(cardId, state);
}
//# sourceMappingURL=state.js.map